export const isFrontDev = window.location.host.indexOf("teachingboost.fr") < 0
